
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';

import MoaFrameBox from '../content/moa-frame-box.vue';

import MoaFrameNotApproved from '../frames/01-moa-frame-not-approved.vue';
import MoaFrameIntroScreenTwo from '../frames/02-moa-frame-intro-screen-2.vue';
import MoaFrameIntroScreenThree from '../frames/03-moa-frame-intro-screen-3.vue';
import MoaFrameHumanOrgans from '../frames/04-moa-frame-human-organs.vue';
import MoaFrameVirusEntry from '../frames/05-moa-frame-virus-entry.vue';
import MoaFrameVirusRna from '../frames/06-moa-frame-protein-created.vue';
import MoaFrameProteinDetach from '../frames/07-moa-frame-protein-detach.vue';
import MoaFramePurpleRnaCreated from '../frames/08-moa-frame-purple-rna-created.vue';
import MoaFrameRnaMove from '../frames/09-moa-frame-rna-move.vue';
import MoaFrameRnaCoiled from '../frames/10-moa-frame-purple-rna-coiled.vue';
import MoaFrameVitaminRelease from '../frames/11-moa-frame-virus-package.vue';
import MoaFrameProteinChainBreak from '../frames/12-moa-frame-protein-chain-break.vue';
import MoaFrameProteinChainSvg from '../frames/13-moa-frame-protein-chain-svg.vue';
import MoaFramePurpleRnaCreatedVersion from '../frames/14-moa-frame-protein-rna.vue';
import MoaFrameMutagenesis from '../frames/15-moa-frame-protein-mpro.vue';
import MoaFrameUnableCut from '../frames/16-moa-frame-unable-cut.vue';
import MoaFrameBond from '../frames/17-moa-frame-callout.vue';
import MoaFrameMutagenesisVersion from '../frames/18-moa-frame-nirm-screen-3.vue';
import MoaFrameRitonavir from '../frames/19-moa-frame-conj-screen-1.vue';
import MoaFrameMolecules from '../frames/20-moa-frame-molecules.vue';
import MoaFramePersonCup from '../frames/21-moa-frame-person-cup.vue';
import MoaCredits from '../frames/22-moa-credits.vue';

export default defineComponent({
	components: {
		MoaFrameBox,
		MoaFrameNotApproved,
		MoaFrameIntroScreenTwo,
		MoaFrameIntroScreenThree,
		MoaFrameHumanOrgans,
		MoaFrameVirusEntry,
		MoaFrameVirusRna,
		MoaFrameProteinDetach,
		MoaFramePurpleRnaCreated,
		MoaFrameRnaMove,
		MoaFrameRnaCoiled,
		MoaFrameVitaminRelease,
		MoaFrameProteinChainBreak,
		MoaFrameProteinChainSvg,
		MoaFramePurpleRnaCreatedVersion,
		MoaFrameMutagenesis,
		MoaFrameUnableCut,
		MoaFrameBond,
		MoaFrameMutagenesisVersion,
		MoaFrameRitonavir,
		MoaFrameMolecules,
		MoaFramePersonCup,
		MoaCredits,
	},
	props: {
		datum: {
			type: Array,
			required: true,
		},
		ready: {
			type: Boolean,
			default: false,
		}
	},
	setup() {
		const store = useStore();

		// Computed active frame
		const activeFrame = computed((): string => store.getters.get_moaActiveFrame);

		return { activeFrame }
	},
})
